import { render, staticRenderFns } from "./ProductPartsList.vue?vue&type=template&id=1d5f67fe&scoped=true&lang=pug&"
import script from "./ProductPartsList.vue?vue&type=script&lang=ts&"
export * from "./ProductPartsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPartsList.vue?vue&type=style&index=0&id=1d5f67fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f67fe",
  null
  
)

export default component.exports